import { Flex, Box } from 'rebass/styled-components'
import CommunicatorWrapper from './components/CommunicatorWrapper';

interface ICommunicatorProps {
  conversationId: number | string
  onSelectConversation: (c:string)=>void
}

export const Communicator: React.FC<ICommunicatorProps> = ({ conversationId,onSelectConversation }) => {
  let convoId
  try {
    convoId = parseInt(conversationId.toString(), 10)
  } catch (error) {

  }
  if (!convoId || isNaN(convoId)) {
    return <Box />
  }
  return (
    <Flex flex={1} style={{ height: '100%', maxHeight: '100%' }}>
      <CommunicatorWrapper conversationId={convoId} onSelectConversation={onSelectConversation} />
    </Flex>);
}
